const START_PAGE = 1;
const RECORD_PER_PAGE = 30;
const INTERVAL_TIME = 1000; // ms
const DISPLAY_MONTHLY = "month";

export default {
    data() {
        return {
            formatInMonth: "MMM-yyyy", // for some report, the date use format month and year
            datepickerMonthFormat: "MMM YYYY",
            START_PAGE: START_PAGE,
            RECORD_PER_PAGE: RECORD_PER_PAGE,
            INTERVAL_TIME: INTERVAL_TIME, // ms
            pagination: this.DEFAULT_PAGINATION()
        };
    },
    methods: {
        billingHeaderTime() {
            return this._now().toFormat(this._dateFormat + " hh:mm a");
        },
        getStartDate(startOf) {
            // startof can be day, week, month, year
            if (startOf == "week") {
                startOf = "isoWeek"; // use isoWeek as week start by Monday
            }
            return moment().tz(this._timeZone).startOf(startOf);
        },
        getEndDate(endOf) {
            // endOf can be day, month, year
            return moment().tz(this._timeZone).endOf(endOf);
        },
        getInitalMonthChart(substractMonth = 5) {
            // most chart will have 6/n months data, current month and previous 5/n months
            return moment()
                .tz(this._timeZone)
                .subtract(substractMonth, "months")
                .startOf("month");
        },
        converToUnix(datemoment) {
            // the date based on getStartDate and getEndDate;;
            return datemoment.clone().unix();
        },
        getDateRange(from, to, format = this._getLuxonFormat()) {
            return (
                " (" +
                this._toDateTime(parseFloat(from)).toFormat(format) +
                " - " +
                this._toDateTime(parseFloat(to)).toFormat(format) +
                ")"
            );
        },
        getDateTimeRange(from, to, format = this._getLuxonFormat()) {
            if (from && to) {
                let dateStart = this._toDateTime(parseFloat(from));
                let dateFrom = dateStart.toFormat(format);
                let dateFromTime = dateStart.toFormat("hh:mm a");

                let dateEnd = this._toDateTime(parseFloat(to));
                let dateTo = dateEnd.toFormat(format);
                let dateToTime = dateEnd.toFormat("hh:mm a");

                const dateFromDisplay = `${dateFrom}, ${dateFromTime}`;
                const dateToDisplay = `${dateTo}, ${dateToTime}`;

                return `(${dateFromDisplay} - ${dateToDisplay})`;
            } else {
                return "--";
            }
        },
        timer(ms) {
            return new Promise(res => setTimeout(res, ms));
        },
        resetPagination() {
            clearInterval(this.pagination.interval);
            this.pagination = this.DEFAULT_PAGINATION();
        },
        DEFAULT_PAGINATION() {
            return {
                page: 1,
                lastPage: 0,
                interval: null,
                current: 0,
                completed: false
            };
        },
        loadingPercentages() {
            clearInterval(this.pagination.interval);
            let self = this;

            let intervalTime =
                self.pagination.page == self.pagination.lastPage ? 30 : 100;

            const totalPercentage = parseInt(
                (self.pagination.lastPage > 0
                    ? self.pagination.page / self.pagination.lastPage
                    : 0.01) * 100
            );
            self.pagination.interval = setInterval(() => {
                if (
                    self.pagination.current >= totalPercentage ||
                    self.pagination.current >= 99
                ) {
                    clearInterval(self.pagination.interval);
                    return;
                }

                self.pagination.current++;
            }, intervalTime);
        },
        loadingCompleted() {
            this.pagination.completed = true;
        },
        defaultToggleHideActions(value) {
            this.data.isHideActions = value;
        },
        defaultToggleOptions(value) {
            // Refactor: Please use isShowActions instead of this function

            // to hide the action menu when data is loading
            // most report will toggle this, additional or different action
            // add the function in the report itself
            this.data.filterDateOption = value;
            this.data.exportOption = value;
            this.data.refreshOption = value;
        },
        defaultFilterDateRange() {
            let self = this;

            self.data.isShowDateRange = true;
            self.data.filterDateOption = true;
            self.data.exportOption = true;
            self.data.exportOptionCsvOnly = false;
            self.data.refreshOption = true;
            self.data.from = moment().tz(this._timeZone);
            self.data.to = moment().tz(this._timeZone);
            self.data.start = moment().tz(this._timeZone);
            self.data.end = moment().tz(this._timeZone);
            self.data.asOf = moment().tz(this._timeZone);
            self.data.statuses = "";
            self.data.module = [
                {
                    value: 1,
                    text: "Schedule"
                }
            ];
            self.data.ignoreFormat = false;
            self.data.datePickerRange = false;
            self.data.datePickerOptions = {
                format: null
            };
            self.data.isFilterDateMonthOnly = false;
            self.data.category = [];
            self.data.exportOptionType = "";
            self.data.filterByOptionDefault = DISPLAY_MONTHLY;
            self.data.isGreyOutButton = false;
            self.data.isShowItemClass = false;
            self.data.isShowItemCategory = false;
            self.data.isShowItemStatus = false;
        },
        openFilterModal() {
            this.$root.$emit("report-filter-date-range:open");
        }
    }
};
